import { COACH, CoachType } from 'types/coach';

export const CoachesMap = {
	FrontPhone: {
		[COACH.LEO]: require('./base64/front-phone/leo').default,
		[COACH.MIA]: require('./base64/front-phone/mia').default,
	},
};

export type CoachesType = keyof typeof CoachesMap;

export const getInlineCoach = (asset: CoachesType, coach: CoachType): string => {
	return `${CoachesMap[asset][coach]}`;
};
